import React from "react";

//Utils
import { mapStyles } from "../../../../Utils/Utils";

//Images
import angelusAntiqueStone from "../../images/styles/style-angelusAntiqueStone.jpg";
import angelusCourtyardStone from "../../images/styles/style-angelusCourtyardStone.jpg";
import angelusHolland from "../../images/styles/style-angelusHolland.jpg";
import angelusHeartlandPaver from "../../images/styles/style-angelusHeartlandPaver.jpg";
import angelusEstateCobble from "../../images/styles/style-angelusEstateCobble.jpg";
import angelusSlaton from "../../images/styles/style-angelusSlaton.jpg";
import belgardCatalinaGrana from "../../images/styles/style-belgardCatalinaGrana.jpg";
import belgardCambridge from "../../images/styles/style-belgardCambridge.jpg";
import belgardHolland from "../../images/styles/style-belgardHolland.jpg";
import angelusPavilion from "../../images/styles/style-angelusPavilion.jpg";
import angelusStoneWall from "../../images/styles/style-angelusStoneWall.jpg";
import belgardSlate from "../../images/styles/style-belgardSlate.jpg";
import artisticStonelock from "../../images/styles/style-artisticStonelock.jpg";
import artisticDesert from "../../images/styles/style-artisticDesert.jpg";
import artisticCorrallock from "../../images/styles/style-artisticCorrallock.jpg";
import belgardLafitt from "../../images/styles/style-belgardLafitt.jpg";
import belgardDublin from "../../images/styles/style-belgardDublin.jpg";
import belgardSubterra from "../../images/styles/style-belgardSubterra.jpg";
import artisticAtlantic from "../../images/styles/style-artisticAtlantic.jpg";
import belgardModuline from "../../images/styles/style-belgardModuline.jpg";
import belgardMegaArbel from "../../images/styles/style-belgardMegaArbel.jpg";
import angelusPaseo from "../../images/styles/style-angelusPaseo.jpg";
import angelusSlatestone from "../../images/styles/style-angelusSlatestone.jpg";
// import angelusCastleCobble from "../../images/styles/style-angelusCastleCobble.jpg";
import artisticTumblelock from "../../images/styles/style-artisticTumblelock.jpg";
import belgardBergerac from "../../images/styles/style-belgardBergerac.jpg";
import belgardUrbana from "../../images/styles/style-belgardUrbana.jpg";
import belgardOldWorldPaver from "../../images/styles/style-belgardOldWorldPaver.jpg";

//SEO
import SEO from "../../../../SEO/index.js";

const Styles = () => {
  const styles = [
    {
      title: "Angelus Antique Stone",
      image: angelusAntiqueStone,
    },
    {
      title: "Angelus Courtyard Stone",
      image: angelusCourtyardStone,
    },
    {
      title: "Angelus Holland",
      image: angelusHolland,
    },
    {
      title: "Angelus Heartland Paver",
      image: angelusHeartlandPaver,
    },
    {
      title: "Angelus Estate Cobble",
      image: angelusEstateCobble,
    },
    {
      title: "Angelus Slaton",
      image: angelusSlaton,
    },
    {
      title: "Belgard Catalina Grana",
      image: belgardCatalinaGrana,
    },
    {
      title: "Belgard Cambridge",
      image: belgardCambridge,
    },
    {
      title: "Belgard Holland",
      image: belgardHolland,
    },
    {
      title: "Angelus Pavilion",
      image: angelusPavilion,
    },
    {
      title: "Angelus StoneWall",
      image: angelusStoneWall,
    },
    {
      title: "Belgard Slate",
      image: belgardSlate,
    },
    {
      title: "Artistic Stonelock",
      image: artisticStonelock,
    },
    {
      title: "Artistic Desert",
      image: artisticDesert,
    },
    {
      title: "Artistic Corrallock",
      image: artisticCorrallock,
    },
    {
      title: "Belgard Lafitt",
      image: belgardLafitt,
    },
    {
      title: "Belgard Dublin",
      image: belgardDublin,
    },
    {
      title: "Belgard Subterra",
      image: belgardSubterra,
    },
    {
      title: "Artistic Atlantic",
      image: artisticAtlantic,
    },
    {
      title: "Belgard Moduline",
      image: belgardModuline,
    },
    {
      title: "Belgard Mega Arbel",
      image: belgardMegaArbel,
    },
    {
      title: "Angelus Paseo",
      image: angelusPaseo,
    },
    {
      title: "Angelus Slatestone",
      image: angelusSlatestone,
    },
    // {
    //   title: "Angelus Castle Cobble",
    //   image: angelusCastleCobble,
    //   destination: "/styles/style/angelus-castle-cobble",
    // },
    {
      title: "Artistic Tumblelock",
      image: artisticTumblelock,
    },
    {
      title: "Belgard Bergerac",
      image: belgardBergerac,
    },
    {
      title: "Belgard Urbana",
      image: belgardUrbana,
    },
    {
      title: "Belgard Old World Paver",
      image: belgardOldWorldPaver,
    },
  ];

  return (
    <>
      <SEO
        title="Paver Stone Styles & Selection | Pacific Pavingstone"
        description="Below is a sample of some of our most popular styles. Because pavers come in a multitude of shapes, colors and sizes, the possibilities are endless."
        profileURL={"https://www.pacificpavingstone.com/styles/style"}
        type="website"
      />
      <div className="row justify-content-center mt-5 page-style">
        <div className="col-11 col-xl-10 no-side-padding">
          <div className="row justify-content-center">
            <div className="col-12">
              <h1 className="text-center text-uppercase">
                Paver Stone Selection
              </h1>
              <p className="text-center mb-5">
                Below is a sample of some of our most popular styles. Because
                pavers come in a multitude of shapes, colors and sizes, the
                possibilities are endless. Call us today to discuss your dream
                project specifics.
              </p>
            </div>
          </div>
          <div className="row justify-content-center justify-content-lg-start">
            {mapStyles(styles)}
          </div>
        </div>
      </div>
    </>
  );
};

export default Styles;
